import { render, staticRenderFns } from "./GerarDoc.vue?vue&type=template&id=4a87d5aa"
import script from "./GerarDoc.vue?vue&type=script&lang=js"
export * from "./GerarDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports